import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { CustomerTypeEnum, HousingTypeEnum, HeatingTypeEnum, TarificationIdEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue";
import ValidationMessage from "../../Default/common/validation-message.vue";
import { HeatingTypeFormat, HousingTypeFormat, GenericTypeFormatTranslator } from "../../../../../Scripts/inpulse/FormatUtils";
import { ValidationErrors } from "../../new-contract-vue";
import { PropertyTypeEnum } from "../../new-contract-vuex-store";
import { IContractViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { SectionChecker } from "../../Default/common/section";
import LoadingComponent from "../../../../../Scripts/vue-components/common/loading.vue";
import { TranslateResult } from "vue-i18n";

class Checker extends SectionChecker {
    constructor() {
        super();
        this.properties = [
            (contract: IContractViewModel) => contract.HousingTypeId,
            (contract: IContractViewModel) => contract.HeatingTypeId,
            (contract: IContractViewModel) => contract.TarificationId,
        ];
        this.validationIds = ["HousingType", "HeatingType", "Tarification"];
    }
}

export const PreProductSelectionChecker = new Checker();

@Component({
    components: {
        ValidatedFormGroup,
        ValidationMessage,
        LoadingIndicator: LoadingComponent
    },
})
export default class PreProductSelection extends Vue {
    loadingIndicator: boolean = false;

    // Map store data to computed properties.
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get postal(): string { return this.$store.state.contract.MeteringPoint.Address.Zip; }
    get heatingType(): HeatingTypeEnum { return this.$store.state.contract.HeatingTypeId; }    
    set heatingType(value: HeatingTypeEnum)
    {
        this.loadingIndicator = true;
        this.$store.dispatch("changeValue", { key: "heatingType", value: value, type: PropertyTypeEnum.BasicValue }).finally(() => {
            this.loadingIndicator = false;
        });
    }
    get housingType(): HousingTypeEnum { return this.$store.state.contract.HousingTypeId; }
    get customerType(): CustomerTypeEnum { return this.$store.state.contract.Customer.Id; }
    get tarification(): TarificationIdEnum { return this.$store.state.contract.TarificationId; }
    set tarification(value: TarificationIdEnum) { this.$store.dispatch("changeValue", { key: "tarification", value: value, type: PropertyTypeEnum.BasicValue }); }
    get houseArea(): number { return this.$store.state.contract.HouseArea; }
    get energy1(): number { return this.$store.state.contract.Energy1; }
    get energy2(): number { return this.$store.state.contract.Energy2; }

    @Prop()
    public validationErrors: ValidationErrors;

    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;
    HousingTypeEnum: typeof HousingTypeEnum = HousingTypeEnum;
    HeatingTypeEnum: typeof HeatingTypeEnum = HeatingTypeEnum;
    TarificationIdEnum: typeof TarificationIdEnum = TarificationIdEnum;

    constructor() {
        super();
    }

    mounted() {
        // tarification (TarificationIdEnum) does not have value 0
        //if (this.tarification == 0) {
        if (!this.tarification) {
            this.$store.dispatch("changeValue", { key: "tarification", value: TarificationIdEnum.SINGLETARIF, type: PropertyTypeEnum.BasicValue })
            this.tarification = TarificationIdEnum.SINGLETARIF;
        }        
    }

    
    get showEnergy2Consumption(): boolean {
        return this.tarification == TarificationIdEnum.DAYNIGHTTARIF || this.tarification == TarificationIdEnum.SEASONTARIF;
    }

    handleApartmentHouse() {
        this.$store.state.contract.HousingTypeId = HousingTypeEnum.APARTMENTHOUSE;
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.DISTRICTHEATING;
        this.$store.state.contract.TarificationId = TarificationIdEnum.SINGLETARIF;
        this.heatingType = HeatingTypeEnum.DISTRICTHEATING;
        this.tarification = TarificationIdEnum.SINGLETARIF;
        $("#heatingType").hide();
        $("#tarification").hide();
    }

    /*
    handleTerracedHouse() {
        this.$store.state.contract.HousingTypeId = HousingTypeEnum.TERRACEDHOUSE;
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.ELECTRICITY;
        this.$store.state.contract.TarificationId = TarificationIdEnum.DAYNIGHTTARIF;
        this.heatingType = HeatingTypeEnum.ELECTRICITY;
        this.tarification = TarificationIdEnum.DAYNIGHTTARIF;
        $("#heatingType").show();
        $("#tarification").show();
    }
    */

    handleTerracedOrDoubleHouse() {
        this.$store.state.contract.HousingTypeId = HousingTypeEnum.TERRACEDORDOUBLEHOUSE;
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.ELECTRICITY;
        this.$store.state.contract.TarificationId = TarificationIdEnum.SINGLETARIF;
        this.heatingType = HeatingTypeEnum.ELECTRICITY;
        this.tarification = TarificationIdEnum.SINGLETARIF;
        $("#heatingType").show();
        $("#tarification").show();
    }

    handleHouse() {
        this.$store.state.contract.HousingTypeId = HousingTypeEnum.HOUSE;
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.ELECTRICITY;
        this.$store.state.contract.TarificationId = TarificationIdEnum.SINGLETARIF;
        this.heatingType = HeatingTypeEnum.ELECTRICITY;
        this.tarification = TarificationIdEnum.SINGLETARIF;
        $("#heatingType").show();
        $("#tarification").show();
    }

    /*
    handleDoubleHouse() {
        this.$store.state.contract.HousingTypeId = HousingTypeEnum.DOUBLEHOUSE;
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.ELECTRICITY;
        this.$store.state.contract.TarificationId = TarificationIdEnum.DAYNIGHTTARIF;
        this.heatingType = HeatingTypeEnum.ELECTRICITY;
        this.tarification = TarificationIdEnum.DAYNIGHTTARIF;
        $("#heatingType").show();
        $("#tarification").show();
    }
    */

    handleCottage() {
        this.$store.state.contract.HousingTypeId = HousingTypeEnum.COTTAGE;
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.ELECTRICITY;
        this.$store.state.contract.TarificationId = TarificationIdEnum.SINGLETARIF;
        this.heatingType = HeatingTypeEnum.ELECTRICITY;
        this.tarification = TarificationIdEnum.SINGLETARIF;
        $("#heatingType").show();
        $("#tarification").show();
    }

    handleOtherConsumer() {
        this.$store.state.contract.HousingTypeId = HousingTypeEnum.OTHER;
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.ELECTRICITY;
        this.$store.state.contract.TarificationId = TarificationIdEnum.SINGLETARIF;
        this.heatingType = HeatingTypeEnum.ELECTRICITY;
        this.tarification = TarificationIdEnum.SINGLETARIF;
        $("#heatingType").show();
        $("#tarification").show();
    }

    handleElectricity() {
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.ELECTRICITY;
        this.heatingType = HeatingTypeEnum.ELECTRICITY;
    }
    handleDH() {
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.DISTRICTHEATING;
        this.heatingType = HeatingTypeEnum.DISTRICTHEATING;
    }
    handleML() {
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.GEOTHERMAL;
        this.heatingType = HeatingTypeEnum.GEOTHERMAL;
    }
    handleOIL() {
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.OIL;
        this.heatingType = HeatingTypeEnum.OIL;
    }
    handleOTHER() {
        this.$store.state.contract.HeatingTypeId = HeatingTypeEnum.OTHER;
        this.heatingType = HeatingTypeEnum.OTHER;
    }

    heatingTypeString(type: HeatingTypeEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(HeatingTypeFormat.toString, type, this.$i18n);
    }

    housingTypeString(type: HousingTypeEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(HousingTypeFormat.toString, type, this.$i18n);
    }


    data() {
        return {
            tarifications: [                
                { value: TarificationIdEnum.SINGLETARIF, text: this.$t('Yksiaika') },
                { value: TarificationIdEnum.DAYNIGHTTARIF, text: this.$t('Yö-päivä') },
                { value: TarificationIdEnum.SEASONTARIF, text: this.$t('Vuodenaikasähkö') }               
            ],
            houseAreas: [
                { value: 'null', text: this.$t('Valitse kohteen pinta-ala'), disabled: true },
                { value: '20', text: '1 - 40' },
                { value: '60', text: '41 - 80' },
                { value: '100', text: '81 - 120' },  
                { value: '145', text: '121 - ' },
            ]
        }
    }

}
